import { RightSectionTableTranslations } from './types';

export const enTranslations: RightSectionTableTranslations = {
    noRecord: "No Record Available",
    actions: "Actions",
    percentage: "Percentage %"
};